import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { OpenLobbyState } from "./types";
import type { LobbyState } from "../../store";
import { queueArticleRender } from "../../articleRenderQueue";

type OpenLobbyLocalState = {
  error: string | null;
};

type OpenLobbyStore = {
  gameState: OpenLobbyState | null;
  lobbyState: LobbyState | null;
  localState: OpenLobbyLocalState;

  clear: () => void;
  update_game: (state: OpenLobbyState) => void;
  update_lobby: (lobbyState: LobbyState) => void;
  render_article: (payload: {
    article_id: number;
    html: string;
    title: string;
  }) => void;
};

export const useOpenLobbyStore = create<OpenLobbyStore>()(
  immer((set) => ({
    gameState: null,
    lobbyState: null,
    localState: {
      error: null,
    },

    clear: () => {
      set((draft) => {
        draft.gameState = null;
        draft.lobbyState = null;
        draft.localState.error = null;
      });
    },

    update_game: (state) => {
      set((draft) => {
        draft.gameState = state;
        draft.localState.error = null;
      });
    },

    update_lobby: (lobbyState) => {
      set((draft) => {
        draft.lobbyState = lobbyState;
        draft.localState.error = null;
      });
    },

    render_article: (payload) => {
      const data = {
        html: payload.html,
        articleId: payload.article_id,
        articleTitle: payload.title,
      };
      queueArticleRender(data);
    },
  })),
);
